import * as Yup from "yup";

export default function ForgotPwValidationSchema() {
  return Yup.object().shape({
    email: Yup.string().email("Invalid email").required("Required"),
  });
}
